const ProjectsData = [
  {
    id: 1,
    heading: "OLX clone app",
    description:
      "An olx clone which has limited functionalities like uploading an ad and displaying the list of ads. Using React, Node, Tailwind, API",
  },
  {
    id: 2,
    heading: "Online shopping app",
    description:
      "A React app for a fictional retail company where one can buy stuff online",
  },
  {
    id: 3,
    heading: "Personal blog website",
    description: "Personal blog website using React, Tailwind, Routers etc.",
  },
];

export default ProjectsData;
